var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7137 0.499939H2.27952C1.29738 0.499939 0.49939 1.30909 0.49939 2.30239V23.6975C0.49939 24.6908 1.29738 25.4999 2.27952 25.4999H23.7137C24.6958 25.4999 25.4994 24.6908 25.4994 23.6975V2.30239C25.4994 1.30909 24.6958 0.499939 23.7137 0.499939ZM8.05519 21.9285H4.34984V9.99771H8.06077V21.9285H8.05519ZM6.20251 8.36824C5.0139 8.36824 4.05408 7.40284 4.05408 6.21981C4.05408 5.03677 5.0139 4.07137 6.20251 4.07137C7.38555 4.07137 8.35095 5.03677 8.35095 6.21981C8.35095 7.40842 7.39113 8.36824 6.20251 8.36824ZM21.9447 21.9285H18.2393V16.1249C18.2393 14.741 18.2114 12.9609 16.3141 12.9609C14.3833 12.9609 14.0876 14.4676 14.0876 16.0245V21.9285H10.3822V9.99771H13.9369V11.6272H13.9871C14.4838 10.6897 15.6947 9.70195 17.4972 9.70195C21.2472 9.70195 21.9447 12.174 21.9447 15.3883V21.9285Z",
    fill: "#918E9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.f6c23309e78849945a3d9dce42769c2f.svg";
export { ForwardRef as ReactComponent };